import z from "zod";
import { ViewSchema } from "@storytell/types";

export const ViewIdParamsSchema = z.object({
  id: z.string(),
});

export const CreateViewInputSchema = ViewSchema.pick({
  name: true,
  description: true,
  filters: true,
});
export type CreateViewInput = z.infer<typeof CreateViewInputSchema>;

export const UpdateViewInputSchema = ViewSchema.pick({
  id: true,
  name: true,
  description: true,
  filters: true,
});
export type UpdateViewInput = z.infer<typeof UpdateViewInputSchema>;
